/* Busca global. */
import { searchResults, type SearchResults } from "@zapir/shared";
import { request } from "./core";

export const searchApi = {
  async search(q: string, scope: string, conversationId?: string): Promise<SearchResults> {
    return request("/search", { query: { q, scope, conversationId }, schema: searchResults });
  },
};
